import * as React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'moment/locale/is';

import 'react-datepicker/dist/react-datepicker.css';

moment.locale('is');

interface GeneralTabProps {
	seriesId: string;
	name: string;
	start: moment.Moment;
	end: moment.Moment;
	onNameChange: (name: string) => void;
	onStartChange: (start: moment.Moment) => void;
	onEndChange: (end: moment.Moment) => void;
	onSave: () => void;
	onDelete: () => void;
}

export default class GeneralTab extends React.Component<GeneralTabProps> {
	render() {
		const { seriesId, name, start, end, onNameChange, onStartChange, onEndChange, onSave, onDelete } = this.props;
		const startDate = moment.isMoment(start) && start.isValid() ? start.toDate() : new Date();
		const endDate = moment.isMoment(end) && end.isValid() ? end.toDate() : new Date();

		return (
			<div className="mt-3">
				<h4>General Information</h4>
				<div className="mb-3">
					<label htmlFor="name" className="form-label">Series Name</label>
					<input 
						type="text" 
						className="form-control" 
						id="name" 
						value={name} 
						onChange={(event) => onNameChange(event.target.value)} 
					/>
				</div>
				<div className="mb-3">
					<label htmlFor="start" className="form-label">Start Date</label>
					<DatePicker 
						id="start" 
						className="form-control" 
						selected={startDate} 
						onChange={(date) => onStartChange(moment(date))} 
						locale="is" 
					/>
				</div>
				<div className="mb-3">
					<label htmlFor="end" className="form-label">End Date</label>
					<DatePicker 
						id="end" 
						className="form-control" 
						selected={endDate} 
						onChange={(date) => onEndChange(moment(date))} 
						locale="is" 
					/>
				</div>

				<div className="btn-group mt-3">
					{seriesId && (
						<button onClick={onDelete} className="btn btn-danger">
							<span className="fa fa-trash me-2"></span>
							Delete Series
						</button>
					)}
					<button onClick={onSave} className="btn btn-success">
						<span className="fa fa-save me-2"></span>
						{seriesId ? 'Save Changes' : 'Create Series'}
					</button>
				</div>
			</div>
		);
	}
}
